import { useEffect, useState } from 'react';
import api from '../../services/api';
import axios from 'axios';
import Rodape from '../../components/Rodape';
import Topo from '../../components/Topo';
import LoginPage from './LoginPage';
import {Animated} from "react-animated-css";
function Login() {

  const [ip, setIp] = useState('');
  const [usuario, setUsuario] = useState('');
  const [senha, setSenha] = useState('');
  const [msg, setMsg] = useState('');
 
  const getData = async () => {
    const res = await axios.get('https://geolocation-db.com/json/');
    setIp(res.data.IPv4);
  };

  const Submit = async (e) => {
    e.preventDefault(0);
    setMsg('Aguarde...');
    
    try{
      var res = await api.post("/Login",{usuario: usuario, senha: senha});
    }catch(e){
      var res = '';
      setMsg('Ocorreu um erro interno...');
    }

    if(res.data.msg){
      setMsg(res.data.msg);
    }else if(res.data.token){
      setMsg('Redirecionando...');
      console.log(res.data);
      window.localStorage.setItem('token', res.data.token);
      if(typeof res.data.vencido != 'undefined') {
        if(res.data.vencido == true) {
          window.location = 'Faturas/' + res.data.faturapendente; 
          return;
        }
      }
      
        window.location = 'Painel'; 

      return;
    }else{
      setMsg('Ocorreu um erro interno...');
    }

  };

  useEffect(()=>{
    if(window.localStorage.getItem('token')){
      window.location = 'Painel'; 
      return;     
    }
    getData();
  }, []);

  return (
    <Animated animationIn="bounceInLeft" animationOut="fadeOut" isVisible={true}>
    <div className="main-content" style={{marginLeft: '0'}}>
      <Topo/>
      <LoginPage Submit={Submit} usuario={usuario} setUsuario={setUsuario} msg={msg} senha={senha} setSenha={setSenha} ip={ip}/>
    </div>
    </Animated>
  );
}

export default Login;
